import { Dropzone, IMAGE_MIME_TYPE } from '@mantine/dropzone';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage, faTrash} from "@fortawesome/sharp-solid-svg-icons";
import styles from "./FileChooser.module.scss";
import { Group, List, Progress, rem, Space, Text } from "@mantine/core";
import { useState } from 'react';
import Resizer from "react-image-file-resizer";

export type CompressedFile = {data:string, name:string, key:string};

// eslint-disable-next-line unused-imports/no-unused-vars
export default function FileChooser(props:{maxFiles:number, uploading?:boolean, uploadProgress:number, filesUpdated: (files : CompressedFile [])=>void})
{

    const [files, setFiles] = useState<CompressedFile[]>([]);

    function deleteFile(key:string)
    {
        let fa2 = files.filter((x)=>{ return x.key!=key});
        setFiles(fa2);
        props.filesUpdated(fa2);
    }

    async function resizeFile(f: File)
    {

        let p = new Promise((resolve)=>
        {
         Resizer.imageFileResizer(
            f,
            1080,
            1080,
            "JPEG",
            80,
            0,
            (uri) => {
            resolve(uri);
            },
            "base64",
            undefined,
            undefined
          );
        });

        let newFile  = (await p) as string;
   

          let fex : CompressedFile =
          {
            name: f.name,
            data: newFile as string,
            key: new Date().getTime().toString()
          }

          return fex;
    }
    
    return (

        <div style={{position:'relative'}}>
{props.uploading && <div className={styles.overlay}><div className={styles.loading}> <Text>Uploading ...</Text><Space h='md'/><Progress value={props.uploadProgress}/></div></div>}



  <Dropzone
      onDrop={async (fs) => 
      {
        let fa2 = [... files];
        for (const x of fs)
        {
            let y = await resizeFile(x);

            if (y)
            {
            fa2.push(y);
            }
        };
        setFiles(fa2);
        props.filesUpdated(fa2);
      }
      }
      maxSize={25 * 1024 ** 2}
      accept={IMAGE_MIME_TYPE}
      maxFiles = {props.maxFiles}
      multiple     
    >
 <Group justify="center" gap="xl"  style={{ minHeight: rem(220), pointerEvents: 'none', position:'relative' }}>



        <Dropzone.Accept>
        <FontAwesomeIcon icon={faImage} size="2xl" />
        </Dropzone.Accept>
        <Dropzone.Reject>
        <FontAwesomeIcon icon={faImage} size="2xl" />
        </Dropzone.Reject>
        <Dropzone.Idle>
        <FontAwesomeIcon icon={faImage} size="2xl" />
        </Dropzone.Idle>

        <div>
          <Text size="xl" inline>
            Drag images here or click to select files
          </Text>
          <Text size="sm" c="dimmed" inline mt={7}>
            Attach up to {props.maxFiles} photos. Each file should not exceed 5mb
          </Text>
        </div>
      </Group>
    </Dropzone>

    {files.length!=0 && <List icon={<FontAwesomeIcon icon={faImage}/>}>
      {files.map(x=> <List.Item key={x.key}>{x.name}<FontAwesomeIcon onClick={()=>deleteFile(x.key)} className={styles.trashFile} icon={faTrash}/></List.Item>)}
      </List>}
    </div>

    );

}